import * as z from 'zod'

export const userRecordUpdateSchema = z.strictObject({
	userName: z.string().optional(),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	email: z.string().optional(),
	mobilePhone: z.string().optional(),
})
export type UserRecordUpdate = z.infer<typeof userRecordUpdateSchema>
